module.exports = __webpack_public_path__ + "static/media/freedom-homes-logo.d7262770.svg";